// Shared curriculum metadata — used by onboarding (CurriculumFineTunePage) and
// the post-onboarding switch flow (SwitchCurriculumPage). Slugs match the
// curricula.slug column in the DB.
//
// MAIN_CURRICULA: visible by default. EXTRA_CURRICULA: hidden behind the
// "More options" expander. The pre-existing onboarding split is preserved.

export const MAIN_CURRICULA = [
  { slug: 'starter_500',   nameKey: 'curriculum.starter500',   descKey: 'curriculum.starter500Desc',   recommended: true },
  { slug: 'sagebooks_500', nameKey: 'curriculum.sagebooks500', descKey: 'curriculum.sagebooks500Desc' },
  { slug: 'hsk_2',         nameKey: 'curriculum.hsk12',        descKey: 'curriculum.hsk12Desc' },
];

export const EXTRA_CURRICULA = [
  { slug: 'hsk_3',   nameKey: 'curriculum.hsk13',  descKey: 'curriculum.hsk13Desc' },
  { slug: 'yct_1_2', nameKey: 'curriculum.yct12',  descKey: 'curriculum.yct12Desc' },
  { slug: 'hsk_1',   nameKey: 'curriculum.hsk1',   descKey: 'curriculum.hsk1Desc' },
  { slug: 'yct_3_4', nameKey: 'curriculum.yct34',  descKey: 'curriculum.yct34Desc' },
];

export const ALL_CURRICULA = [...MAIN_CURRICULA, ...EXTRA_CURRICULA];
